import { render } from "./DualSelectInput.vue?vue&type=template&id=a0e4ebbc&scoped=true"
import script from "./DualSelectInput.vue?vue&type=script&lang=js"
export * from "./DualSelectInput.vue?vue&type=script&lang=js"

import "./DualSelectInput.vue?vue&type=style&index=0&id=a0e4ebbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0e4ebbc"]])

export default __exports__